import { Loader2 } from 'lucide-react';

export interface LessonBootLoadingProps {
  /**
   * `true` while the lesson is genuinely being built for the first time,
   * `false` when an already-built lesson is merely being fetched.
   */
  creating: boolean;
}

/**
 * The pre-overview screen (§2.8 #9) — everything the lesson route can show
 * before it has a title to put in a header.
 *
 * The two variants are not cosmetic. "Creating your lesson" sets an
 * expectation measured in tens of seconds and earns its reassurance line;
 * "Loading lesson" promises something much shorter. Showing the wrong one
 * makes a fast page feel broken or a slow one feel hung, which is why the
 * page derives `creating` from the pipeline state rather than defaulting.
 */
export function LessonBootLoading({ creating }: LessonBootLoadingProps) {
  return (
    <div className='flex min-h-screen items-center justify-center'>
      <div className='flex flex-col items-center gap-4 px-4 text-center'>
        <Loader2 className='h-9 w-9 animate-spin text-brand-500 motion-reduce:animate-none dark:text-primary' />
        <p className='text-xl font-semibold text-foreground'>
          {creating ? 'Creating your lesson' : 'Loading lesson'}
        </p>
        {creating && (
          <p className='max-w-sm text-sm text-muted-foreground'>
            Setting things up. This only takes a moment.
          </p>
        )}
      </div>
    </div>
  );
}
